import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://sonna-backend.onrender.com/api/v1',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized responses (token expired, not logged in, etc.)
    if (error.response?.status === 401) {
      // Clear any stored tokens
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');

      // Redirect to login or refresh token if you have refresh token logic
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const register = (data) => api.post('/auth/register', data);

export const resendVerification = (email) =>
  api.post('/auth/resend-verification', { email });

export default api;